/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Button, Grid, Typography } from '@mui/material';
import { selectOrganizationId } from 'modules/common/auth/selectors';
import { rateCalenderActions } from 'modules/rate-calendar/slice';
import { selectHotelName } from 'modules/dashboard/selectors';
import { useDispatch, useSelector } from 'react-redux';
/**
 * Delete event popup is defined here
 * @param {*} param0
 * @returns
 */
const DeleteEvent = ({ deleteEventId, setDeleteSelected }) => {
  const dispatch = useDispatch();
  //
  const organizationId = useSelector(selectOrganizationId);
  const hotel = useSelector(selectHotelName);
  //
  const onDeleteEvent = () => {
    dispatch(
      rateCalenderActions.deleteEventDetails({
        organizationId,
        hotelId: hotel.id,
        id: deleteEventId,
      })
    );
    setDeleteSelected(false);
  };
  //
  return (
    <Grid
      container
      sx={{
        backgroundColor: 'red',
        color: 'white',
        borderRadius: 5,
      }}
      alignSelf="center"
      m={4}
      p={4}
    >
      <Typography>Confirm to delete this event? </Typography>
      <div>
        <Button sx={{ color: 'white' }} onClick={() => onDeleteEvent()}>
          Yes
        </Button>
        <Button sx={{ color: 'white' }} onClick={() => setDeleteSelected(false)}>
          No
        </Button>
      </div>
    </Grid>
  );
};
//
export default DeleteEvent;
